var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0886 7.41205C13.414 7.73748 13.414 8.26512 13.0886 8.59056L8.0886 13.5906C7.76317 13.916 7.23553 13.916 6.91009 13.5906C6.58466 13.2651 6.58466 12.7375 6.91009 12.412L11.9101 7.41205C12.2355 7.08661 12.7632 7.08661 13.0886 7.41205Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1628 5.62265L9.79796 6.045C9.49711 6.39329 8.97088 6.43174 8.62259 6.13089C8.2743 5.83003 8.23584 5.3038 8.5367 4.95551L8.92253 4.50884C8.93579 4.49349 8.94961 4.47863 8.96395 4.46429C9.90175 3.52663 11.1736 2.99991 12.4998 3C13.8259 3.00009 15.0977 3.52699 16.0354 4.46479C16.973 5.40259 17.4998 6.67446 17.4997 8.00061C17.4996 9.32676 16.9727 10.5986 16.0349 11.5362C16.0211 11.55 16.0069 11.5632 15.9922 11.576L15.5472 11.9626C15.1998 12.2645 14.6735 12.2276 14.3716 11.8802C14.0698 11.5328 14.1067 11.0064 14.4541 10.7045L14.8758 10.3381C15.4889 9.71488 15.8329 8.87543 15.833 8.00049C15.8331 7.11637 15.4819 6.26843 14.8568 5.64322C14.2317 5.01801 13.3838 4.66673 12.4997 4.66667C11.6251 4.6666 10.786 5.01019 10.1628 5.62265Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6246 9.11359C5.92934 9.45848 5.89679 9.98511 5.5519 10.2899L5.13374 10.6593C4.82977 10.9639 4.58806 11.3249 4.42221 11.7222C4.25352 12.1262 4.16667 12.5596 4.16667 12.9975C4.16667 13.4353 4.25352 13.8687 4.42221 14.2728C4.59089 14.6768 4.83805 15.0433 5.14938 15.3511L5.1494 15.3512C5.78402 15.9787 6.64053 16.3307 7.53304 16.3307C8.40557 16.3307 9.24369 15.9943 9.87372 15.3929L10.1647 15.0015C10.4393 14.6322 10.9613 14.5554 11.3306 14.8299C11.7 15.1045 11.7768 15.6265 11.5022 15.9959L11.1714 16.4409C11.1462 16.4747 11.1185 16.5066 11.0886 16.5363C10.1419 17.4723 8.86434 17.9974 7.53304 17.9974C6.20174 17.9974 4.92415 17.4724 3.97753 16.5363C3.50944 16.0734 3.13783 15.5223 2.88421 14.9149C2.63059 14.3075 2.5 13.6557 2.5 12.9975C2.5 12.3392 2.63059 11.6875 2.88421 11.08C3.13783 10.4726 3.50945 9.92147 3.97753 9.45864C3.98861 9.44768 3.99999 9.43704 4.01167 9.42673L4.44833 9.04089C4.79323 8.73615 5.31986 8.7687 5.6246 9.11359Z",
    fill: "#4B4AD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink1);
export default __webpack_public_path__ + "static/media/link1.5a66f0ec2837f388579a450b03405f18.svg";
export { ForwardRef as ReactComponent };